import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-alinhar-texto-esquerda" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_9 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_10 = { class: "ant-input-group-addon" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_15 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_16 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Consultar CEP nos correios", -1)
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Salvar Dados", -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _ctx.state.salvandoInformacoes
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: "CPF",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_cpf, {
                      valor: _ctx.computedContabilista.cpfCnpj,
                      "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedContabilista.cpfCnpj) = $event))
                    }, null, 8, ["valor"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Nome completo",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "250",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedContabilista.nome) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedContabilista.nome]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: "CRC",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedContabilista.crc) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedContabilista.crc]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: "CNPJ da Contabilidade",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_cnpj, {
                      valor: _ctx.computedContabilista.cnpjContabilidade,
                      "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedContabilista.cnpjContabilidade) = $event))
                    }, null, 8, ["valor"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_card, { titulo: "CONTATO" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "E-mail",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              nome: "email"
                            })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedContabilista.email) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.computedContabilista.email]
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "Telefone",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.computedContabilista.telefone,
                          "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedContabilista.telefone) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_form_item, {
                      label: "FAX",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.computedContabilista.fax,
                          "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedContabilista.fax) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_card, { titulo: "ENDEREÇO" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "CEP",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_campo_cep, {
                            valor: _ctx.computedContabilista.endereco.cep,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedContabilista.endereco.cep) = $event)),
                            onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.consultaCEP($event.target.value)))
                          }, null, 8, ["valor"]),
                          _createElementVNode("span", _hoisted_16, [
                            _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                              title: _withCtx(() => [
                                _hoisted_17
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.consultaCEP(_ctx.computedContabilista.endereco.cep)))
                                }, [
                                  _createVNode(_component_icone, { nome: "cep" })
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, {
                      label: "Endereço/Avenida/Rua",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "60",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedContabilista.endereco.logradouro) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.computedContabilista.endereco.logradouro]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, {
                      label: "Número",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "10",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedContabilista.endereco.numero) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.computedContabilista.endereco.numero]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, {
                      label: "Complemento",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "60",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedContabilista.endereco.complemento) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.computedContabilista.endereco.complemento]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, {
                      label: "Bairro",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "60",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.computedContabilista.endereco.bairro) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.computedContabilista.endereco.bairro]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, {
                      label: "Cidade/Estado",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_cidade, {
                          codigoSelecionado: _ctx.computedContabilista.endereco.codigoCidade,
                          "onUpdate:codigoSelecionado": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedContabilista.endereco.codigoCidade) = $event)),
                          apresentarEstado: true
                        }, null, 8, ["codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-primary ss-tamanho-completo",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.salvar()))
              }, _hoisted_27)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["spinning"]))
}